import { render, staticRenderFns } from "./MisCarteras.vue?vue&type=template&id=65c3f23d&"
import script from "./MisCarteras.vue?vue&type=script&lang=js&"
export * from "./MisCarteras.vue?vue&type=script&lang=js&"
import style0 from "./MisCarteras.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports